const Calendar = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='4'
      y='4'
      width='16'
      height='16'
      rx='3.75'
      stroke='#131313'
      strokeWidth='1.8'
    />
    <path
      d='M16 2.40039V5.60039'
      stroke='#131313'
      strokeWidth='1.8'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8 2.40039V5.60039'
      stroke='#131313'
      strokeWidth='1.8'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M4 10H20' stroke='#131313' strokeWidth='1.8' />
    <circle cx='15.5' cy='15.5' r='1' stroke='#131313' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.9996 1.5C16.4967 1.5 16.8996 1.90294 16.8996 2.4V3.19126C17.432 3.25787 17.9116 3.37803 18.3607 3.60686C19.2356 4.05267 19.947 4.76403 20.3928 5.63898C20.6726 6.18809 20.7899 6.78278 20.8455 7.46376C20.8996 8.12585 20.8996 8.94407 20.8996 9.96134V14.0387C20.8996 15.056 20.8996 15.8742 20.8455 16.5363C20.7899 17.2173 20.6726 17.812 20.3928 18.3611C19.947 19.236 19.2356 19.9474 18.3607 20.3932C17.8116 20.673 17.2169 20.7903 16.5359 20.846C15.8738 20.9001 15.0556 20.9 14.0383 20.9H9.96091C8.94364 20.9 8.12542 20.9001 7.46333 20.846C6.78235 20.7903 6.18766 20.673 5.63855 20.3932C4.7636 19.9474 4.05224 19.236 3.60643 18.3611C3.32665 17.812 3.20933 17.2173 3.15369 16.5363C3.09959 15.8742 3.0996 15.056 3.09961 14.0387V9.96134C3.0996 8.94407 3.09959 8.12585 3.15369 7.46376C3.20933 6.78278 3.32665 6.18809 3.60643 5.63898C4.05224 4.76403 4.7636 4.05267 5.63855 3.60686C6.08766 3.37803 6.56725 3.25788 7.09961 3.19126V2.4C7.09961 1.90294 7.50255 1.5 7.99961 1.5C8.49667 1.5 8.89961 1.90294 8.89961 2.4V3.10287C9.22694 3.10003 9.57993 3.10003 9.96082 3.10004H9.96092H14.0383H14.0384C14.4193 3.10003 14.7723 3.10003 15.0996 3.10287V2.4C15.0996 1.90294 15.5026 1.5 15.9996 1.5ZM7.09961 5.01069V5.6C7.09961 6.09706 7.50255 6.5 7.99961 6.5C8.49667 6.5 8.89961 6.09706 8.89961 5.6V4.903C9.22444 4.90014 9.58811 4.90004 9.99961 4.90004H13.9996C14.4111 4.90004 14.7748 4.90014 15.0996 4.903V5.6C15.0996 6.09706 15.5026 6.5 15.9996 6.5C16.4967 6.5 16.8996 6.09706 16.8996 5.6V5.01069C17.178 5.0596 17.3776 5.12613 17.5435 5.21067C18.0797 5.48391 18.5157 5.9199 18.789 6.45616C18.9179 6.70923 19.005 7.04067 19.0515 7.61033C19.0843 8.01124 19.0947 8.49065 19.0981 9.10004H4.90117C4.9045 8.49065 4.91496 8.01124 4.94771 7.61033C4.99426 7.04067 5.0813 6.70923 5.21024 6.45616C5.48348 5.9199 5.91947 5.48391 6.45574 5.21067C6.62165 5.12613 6.82126 5.0596 7.09961 5.01069ZM4.89961 10.9H19.0996V14C19.0996 15.065 19.0989 15.8096 19.0515 16.3897C19.005 16.9594 18.9179 17.2908 18.789 17.5439C18.5157 18.0802 18.0797 18.5162 17.5435 18.7894C17.2904 18.9183 16.959 19.0054 16.3893 19.0519C15.8091 19.0993 15.0646 19.1 13.9996 19.1H9.99961C8.93466 19.1 8.19008 19.0993 7.60991 19.0519C7.04024 19.0054 6.7088 18.9183 6.45574 18.7894C5.91947 18.5162 5.48348 18.0802 5.21024 17.5439C5.0813 17.2908 4.99426 16.9594 4.94771 16.3897C4.90031 15.8096 4.89961 15.065 4.89961 14V10.9ZM15.4996 17C16.328 17 16.9996 16.3284 16.9996 15.5C16.9996 14.6716 16.328 14 15.4996 14C14.6712 14 13.9996 14.6716 13.9996 15.5C13.9996 16.3284 14.6712 17 15.4996 17Z'
      fill='#131313'
    />
  </svg>
)

export default Calendar
